import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import _ from 'lodash';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { IAuthState } from 'src/modules/Auth/store/types';
import { IReduxState } from 'src/reduxTypes';
import AgencyFilter from 'src/share/components/AgencyFilter/AgencyFilter';
import DatesChart from 'src/share/components/Chart/ChartDays';
import { StatisticsService, StatsTypes } from 'src/share/services/statistics';
import MonthlyFilter, { IMonthOption } from 'src/share/components/MonthlyFilter/MonthlyFilter';
import { initialGeoSearchStats, IGeoSearchStats } from 'src/share/types/geoSearch';
import { countUp } from 'src/modules/Dashboard/Global/components/CountUp';
import CircleChart from 'src/share/components/Chart/CircleChart';
import ChartBars from 'src/share/components/Chart/ChartBars';
import { getOptions } from 'src/share/utils/utils';
import { ReportsService, ReportTypes, MatchReportsOptions, GeoSearchReportsOptions } from 'src/share/services/reports';
import { RoutesModules } from 'src/modules/Routing/types';
import ChartLoader from 'src/share/components/ChartLoader/ChartLoader';
import { YearLoader } from 'src/share/components/ChartLoader/YearLoader';
import { AbductorLoader } from 'src/share/components/ChartLoader/AbductorLoader';
import { SexLoader } from 'src/share/components/ChartLoader/SexLoader';
import './geosearchStats.css';

export interface IGeoSearchStatsProps {
  auth: IAuthState;
  location: Location;
}

export interface IGeoSearchStatsState {
  agencyCode: string;
  geoSearchStats: IGeoSearchStats;
  loading: boolean;
  loadingReport: string;
  options: IMonthOption[];
  selected: IMonthOption;
}

export class GeoSearchStats extends React.Component<IGeoSearchStatsProps, IGeoSearchStatsState> {
  constructor(props: IGeoSearchStatsProps) {
    super(props);
    const options = getOptions();
    this.state = {
      agencyCode: props.auth.agencyCode,
      geoSearchStats: _.cloneDeep(initialGeoSearchStats),
      loading: true,
      loadingReport: '',
      options,
      selected: options[0]
    }
  }

  public componentDidMount() {
    this.loadData();
  }

  public async loadData() {
    try {
      this.setState({ loading: true });
      const { agencyCode, selected: { gte, lte } } = this.state
      const filters = { agencyCode, range: { gte, lte } };
      const geoSearchStats = await StatisticsService.getStats(StatsTypes.GEOSEARCH, filters);
      this.setState({ geoSearchStats, loading: false });
    } catch {
      toastr.error('Error', 'There was a problem loading the Geo search stats');
      this.setState({ loading: false });
    }
  }

  public changeMonth = async (selected: IMonthOption) => {
    this.setState({ selected }, () => this.loadData())
  }

  public changeAgency = async (agencyCode) => {
    this.setState({ agencyCode }, () => this.loadData())
  }

  public getReport = (type) => async () => {
    try {
      this.setState({ loadingReport: type });
      const { agencyCode, selected: { gte, lte } } = this.state;
      const filters = { agencyCode, range: { gte, lte } };
      await ReportsService.get(ReportTypes.GEOSEARCH, type, filters);
    } catch (error) {
      toastr.error('Error', 'There was a problem getting the report');
    }
    this.setState({ loadingReport: '' });
  }

  public render() {
    const { geoSearchStats: { agenciesSearches, agenciesPhotosResults, dailySearches,
      totalResultsImages, totalSearches, totalMatches, totalFacesDetected, totalImagesWithFaces },
      agencyCode, loading, loadingReport } = this.state;
    const { auth } = this.props;
    return (
      <div className="geosearch-stats">
        <AgencyFilter changeAgency={this.changeAgency} showOnlyAdmin={auth.agencyCode === 'ALL'} loading={loading} />
        <MonthlyFilter changeSelected={this.changeMonth} options={this.state.options} selected={this.state.selected} />
        <Row>
          <Col className="col-12 no-padding-left totals">
            <Col className="col-12 content white-background">
              <Row>
                <Col xs={12} md={4}><h3>Searches: {!loading && <span>{countUp(totalSearches)}</span>}</h3></Col>
                <Col xs={12} md={4}><h3>Images Results: {!loading && <span>{countUp(totalResultsImages)}</span>}</h3></Col>
                {auth.agencyCode === 'ALL' && agencyCode === 'ALL' && <Col xs={12} md={4}><h3>Matches: {!loading && <span>{countUp(totalMatches)}</span>}</h3></Col>}
              </Row>
              {auth.agencyCode === 'ALL' && agencyCode === 'ALL' &&
                <Row>
                  <Col xs={12} md={4}><h3>Faces Detected: {!loading && <span>{countUp(totalFacesDetected)}</span>}</h3></Col>
                  <Col xs={12} md={4}><h3>Images With Faces: {!loading && <span>{countUp(totalImagesWithFaces)}</span>}</h3></Col>
                  <Col xs={12} md={4}><h3>Agencies: {!loading && <span>{countUp(agenciesSearches.length)}</span>}</h3></Col>
                </Row>}
            </Col>
          </Col>
        </Row>
        <Row>
          <Col className="col-12 no-padding-left">
            <Col className="col-12 content white-background">
              <Header text={"Daily searches "} id='dailySearches' action={this.getReport(MatchReportsOptions.DAILY_MANUAL_SEARCHES)} loading={loadingReport} download={dailySearches.length > 0} />
              <ChartLoader chart={DatesChart} loader={YearLoader} data={dailySearches} dataKey={'Searches'} strokePrimary={true} loading={loading} />
            </Col>
          </Col>
        </Row>
        {agencyCode === 'ALL' &&
          <Row className="margin-big-card half-cards">
            <Col className="col-md-6 col-12 no-padding-left">
              <Col className="col-12 imps content white-background">
                <Header text={"Searches by agency "} id='SearchesByAgency' action={this.getReport(MatchReportsOptions.MANUAL_SEARCHES_BY_AGENCY)} loading={loadingReport} download={agenciesSearches.length > 0} />
                <ChartLoader chart={CircleChart} loader={SexLoader} data={agenciesSearches} loading={loading} />
              </Col>
            </Col>
            <Col className="col-md-6 col-12 no-padding-right">
              <Col className="col-12 imps content white-background">
                <Header text={"Photos results by agency "} id='PhotosResultsByAgency' action={this.getReport(GeoSearchReportsOptions.MANUAL_PHOTOS_RESULTS_BY_AGENCY)} loading={loadingReport} download={agenciesPhotosResults.length > 0} />
                <ChartLoader chart={ChartBars} chartSyncId="PhotosResultsByAgency" loader={AbductorLoader} data={agenciesPhotosResults} loading={loading} />
              </Col>
            </Col>
          </Row>}
      </div>
    );
  }
}

const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});

export default SidebarContainer(RoutesModules.GEOSEARCH)(connect(mapStateToProps, null)(GeoSearchStats));

const Header: React.SFC<{ id: string, loading: string, text: string, action: () => void, download?: boolean }> = (props) => {
  return (
    <h5>
      {props.text}
      {props.download && <div onClick={props.action} className="subOption">
        {props.loading !== props.id && "(download)"}
        {props.loading === props.id && <i className="fa fa-circle-o-notch fa-spin fa-1x fa-fw" />}
      </div>}
    </h5>
  );
};